import {
  affectedSiteNames,
  isInsufficientSafeguardingOfficersError
} from '../../../../features/organisation/utils/safeguardingError'

// Maps a save error to the profile-edit safeguarding modal state. Returns null
// when the error is anything other than the last-safeguarding-officer block, so
// the caller can fall through to its other error handling.
export const safeguardingModalStateFromError = (
  err: unknown
): { siteNames: string[] } | null =>
  isInsufficientSafeguardingOfficersError(err)
    ? { siteNames: affectedSiteNames(err) }
    : null
